import template from './per-diem-rates.html';
import controller from './per-diem-rates.controller';

let perDiemRatesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default perDiemRatesComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/per-diem-rates/per-diem-rates.component.js